export const anneesConstants = {
  GET_ANNEES: "GET_ANNEES",
  GET_ANNEE: "GET_ANNEE",
};
